import { VideoJSPlayer } from 'video.js';
import type { PlayerID, VideoState } from './types';
import { seekShortcutDeltaSecs } from './pop-out-video.constants';

export const currentVideoCanBeUnPopped = (playerMap: VideoState): boolean => {
  const currentId = playerMap.popOutState.id;
  if (!currentId) {
    return false;
  }
  const metadata = playerMap[currentId];
  if (!metadata) {
    return false;
  }

  return !!metadata.sourceContainer.current;
};

export const popOutGoFullScreen = (playerMap: VideoState) => {
  if (!playerMap.activeVideoState.id) {
    return;
  }

  const playerMeta = playerMap[playerMap.activeVideoState.id];
  if (!playerMeta || !playerMeta.controller) {
    return;
  }

  playerMeta.controller.requestFullscreen();
};

export const isPaused = (
  playerMap: VideoState,
  playerId: PlayerID,
): boolean => {
  const playerMeta = playerMap[playerId];
  if (!playerMeta || !playerMeta.controller) {
    return true;
  }

  return playerMeta.controller.paused();
};

export const inlinePlayerVisibilityState = (
  playerMap: VideoState,
  id: PlayerID,
): string | null => {
  return playerMap?.[id]?.sourceContainerVisibilityState || null;
};

export const playVideo = (playerMap: VideoState, playerId: PlayerID) => {
  const playerMeta = playerMap[playerId];
  if (!playerMeta || !playerMeta.controller) {
    return;
  }

  playerMeta.controller.play();
};

export const pauseVideo = (
  playerMap: VideoState,
  playerId: PlayerID | null,
) => {
  if (!playerId) {
    return;
  }
  const playerMeta = playerMap[playerId];
  if (!playerMeta || !playerMeta.controller) {
    return;
  }

  playerMeta.controller.pause();
};

export const togglePlayState = (
  playerMap: VideoState,
  playerId: PlayerID | null,
) => {
  if (!playerId) {
    return;
  }
  if (isPaused(playerMap, playerId)) {
    playVideo(playerMap, playerId);
  } else {
    pauseVideo(playerMap, playerId);
  }
};

export const handleVideoSeekShortcuts = (
  evt: KeyboardEvent,
  playerInstance?: VideoJSPlayer | null,
) => {
  if (!evt.shiftKey || !playerInstance) {
    return false;
  }

  switch (evt.key) {
    case 'ArrowLeft':
      playerInstance.currentTime(
        playerInstance.currentTime() - seekShortcutDeltaSecs,
      );
      break;
    case 'ArrowRight':
      playerInstance.currentTime(
        playerInstance.currentTime() + seekShortcutDeltaSecs,
      );
      break;
  }
};
